"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Rueckpfeil auf dem Klickweg
// ============================================================
// Der Verweis im `PageHeader`. Auf dem Server und beim Hydrieren
// steht das feste Ziel da (`/projekte`), gleich danach die Seite,
// von der man in diesem Reiter tatsaechlich gekommen ist — oder,
// ohne Weg davor, das feste Ziel mit dem zuletzt benutzten Filter.
// Begruendung in `lib/return-address.ts`.
//
// Ein echter Verweis und kein Klickhorcher: Ueberfahren zeigt die
// ganze Adresse, Mittelklick oeffnet sie im neuen Reiter. Nur der
// einfache Klick kuerzt den Weg, denn nur er geht hier zurueck.
// ============================================================

import { useSyncExternalStore } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { currentReturnTarget, returnTo, subscribeReturnAddress } from "@/lib/return-address";

const TRENNER = "\u0000";

export function ReturnLink({
  back,
  className,
  children,
}: {
  back: { href: string; label: string };
  className?: string;
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  // Eine Zeichenkette als Stand: `useSyncExternalStore` vergleicht
  // mit `Object.is`, ein neues Objekt je Aufruf liefe im Kreis.
  const stand = useSyncExternalStore(
    subscribeReturnAddress,
    () => {
      const ziel = currentReturnTarget(pathname, back);
      return [ziel.index, ziel.href, ziel.label ?? ""].join(TRENNER);
    },
    () => null,
  );
  let index = -1;
  let href = back.href;
  let label: string | null = back.label;
  if (stand) {
    const teile = stand.split(TRENNER);
    index = Number(teile[0]);
    href = teile[1];
    label = teile[2] || null;
  }
  const text = label ? `Zurück zu ${label}` : "Zurück";

  return (
    <Link
      href={href}
      aria-label={text}
      title={text}
      className={className}
      onClick={(e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        returnTo(index);
      }}
    >
      {children}
    </Link>
  );
}
